import { render, staticRenderFns } from "./EditTreatment.vue?vue&type=template&id=1c4b1e18&scoped=true"
import script from "./EditTreatment.vue?vue&type=script&lang=js"
export * from "./EditTreatment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c4b1e18",
  null
  
)

export default component.exports